import Region, { type RegionFieldProps } from '../../../components/fields/RegionField';
import InputField from './InputField';
import SelectField from './SelectField';

const RegionField = (props: RegionFieldProps) => <Region InputComp={InputField} SelectComp={SelectField} {...props} />;

export default RegionField;
